import { BASE_URL } from "../common/constants";
import axios from "axios";
import { CardPictureVote } from '../common/card-model';
import { withTokenCheck } from "./userAxiosServices"

const guestCardPictures = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  guessesScore
}: Pick<CardPictureVote, "id" | "categoryId" | "sideOne" | "sideTwo" | "guessesScore">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    guesses_score: guessesScore,
  }
  const response = axios.put(BASE_URL + `card/card-picture/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      'content-Type': 'multipart/form-data'
    }
  });
  return response;
}

export const guestCardPictureService = withTokenCheck(guestCardPictures)

const incorrectGuestCardPicture = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  incorrectGuessesScore
}: Pick<CardPictureVote, "id" | "categoryId" | "sideOne" | "sideTwo" | "incorrectGuessesScore">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    incorrect_guesses_score: incorrectGuessesScore,
  }
  const response = axios.put(BASE_URL + `card/card-picture/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      'content-Type': 'multipart/form-data'
    }
  });
  return response;
}

export const incorrectGuestCardPictureService = withTokenCheck(incorrectGuestCardPicture)

const guestTypingCardPicture = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  guessesScoreTyping
}: Pick<CardPictureVote, "id" | "categoryId" | "sideOne" | "sideTwo" | "guessesScoreTyping">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    guesses_score_typing: guessesScoreTyping,
  }
  const response = axios.put(BASE_URL + `card/card-picture/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      'content-Type': 'multipart/form-data'
    }
  });
  return response;
}

export const guestTypingCardPictureService = withTokenCheck(guestTypingCardPicture)

const incorrectGuestTypingCardPicture = async ({
  id,
  categoryId,
  sideOne,
  sideTwo,
  incorrectGuessesScoreTyping
}: Pick<CardPictureVote, "id" | "categoryId" | "sideOne" | "sideTwo" | "incorrectGuessesScoreTyping">) => {
  const body = {
    category: categoryId,
    first_side: sideOne,
    second_side: sideTwo,
    incorrect_guesses_score_typing: incorrectGuessesScoreTyping,
  }
  const response = axios.put(BASE_URL + `card/card-picture/${id}/`, body, {
    headers: {
      Authorization: `JWT ${localStorage.getItem('access')}`,
      'content-Type': 'multipart/form-data'
    }
  });
  return response;
}

export const incorrectGuestTypingCardPictureService = withTokenCheck(incorrectGuestTypingCardPicture)


